<template>
    <modal id="course-modal"
           size="large"
           style="height: 100%"
           v-model="showModal"
           :title="generateModalTitle('employee_course')"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader">
        <form
            ref="form"
            @submit.prevent="submitData">
            <div class="row">
                <div class="col-md-6">
                    <app-form-group-selectable
                        type="search-select"
                        :label="$t('course')"
                        list-value-field="title"
                        :chooseLabel="$t('course')"
                        v-model="formData.course_id"
                        :required="true"
                        :error-message="$errorMessage(errors, 'course_id')"
                        :fetch-url="`${apiUrl.TENANT_SELECTABLE_COURSE}`"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('description')"
                        type="text"
                        v-model="formData.description"
                        :placeholder="$placeholder('description')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'description')"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('start_date')"
                        type="date"
                        date-mode="date"
                        v-model="formData.start_date"
                        :placeholder="$placeholder('start_date')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'start_date')"
                    />
                </div>
                <div class="col-md-6">
                    <app-form-group
                        :label="$t('end_date')"
                        type="date"
                        date-mode="date"
                        v-model="formData.end_date"
                        :placeholder="$placeholder('end_date')"
                        :required="true"
                        :error-message="$errorMessage(errors, 'end_date')"
                    />
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import {errorMessageInArray, formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";
import {TENANT_SELECTABLE_COURSE} from "../../../../Config/ApiUrl";
import {formatDateForServer, formatDateTimeForServer} from "../../../../../common/Helper/Support/DateTimeHelper";

export default {
    name: "EmployeeCourse",
    components: {},
    mixins: [ModalMixin, FormHelperMixins],
    props: {
        employee: {}
    },
    data() {
        return {
            errorMessageInArray,
            formData: {},
            TENANT_SELECTABLE_COURSE,
        };
    },
    computed: {},
    mounted() {
        this.$nextTick(() => {
            if (window.innerHeight < 700) {
                document.getElementsByClassName('modal-body')[0].style.height = '560px'
            }
        })
    },
    methods: {
        submitData() {
            this.loading = true;
            const formData = {...this.formData};
            formData.employee_id = this.employee.id;
            formData.start_date = formatDateForServer(this.formData.start_date);
            formData.end_date = formatDateForServer(this.formData.end_date);

            this.submitFromFixin(
                'post',
                `${this.apiUrl.EMPLOYEES}/add-course`,
                formData
            );
        },
        afterSuccess({data}) {
            this.loading = false;
            $('#course-modal').modal('hide');
            this.$toastr.s('', data.message);
            if (this.tableId) {
                this.$hub.$emit(`reload-${this.tableId}`);
            } else {
                this.$emit('reload')
            }
        },
        created() {
            if (this.specificId) {
                this.formData.employee_id = this.specificId
            }
        },
    }
}
</script>
